<template>
    <div class="dropdown">
        <b-dropdown
            id="dropdown-1"
            variant="white"
            toggle-class="text-decoration-none"
            dropleft
            no-caret
        >
            <template #button-content>
                <font-awesome-icon icon="bars" style="color: white"></font-awesome-icon>
            </template>
            <b-dropdown-item
                v-if="
                    $router.currentRoute.path === '/changelog' ||
                        $router.currentRoute.path === '/inspectionsList' ||
                        $router.currentRoute.path === '/transmission'
                "
                @click="$router.push({ path: '/home' })"
            >
                Início
            </b-dropdown-item>

            <b-dropdown-item
                v-if="$router.currentRoute.path === '/inspectionsList'"
                v-b-modal.modal-import-db
            >
                Importar dados
            </b-dropdown-item>

            <b-dropdown-item
                v-if="$router.currentRoute.path === '/inspectionsList'"
                @click.prevent="exportarBanco"
            >
                Exportar dados <font-awesome-icon icon="download" style="margin-left: auto;"></font-awesome-icon>
            </b-dropdown-item>

            <b-dropdown-item
                v-if="
                    $route.name !== 'Home' &&
                        $router.currentRoute.path !== '/changelog' &&
                        $router.currentRoute.path !== '/inspectionsList' &&
                        $router.currentRoute.path !== '/transmission'
                "
                @click="cancelInspection"
            >
                Cancelar Vistoria
            </b-dropdown-item>

            <b-dropdown-item
                v-if="
                    $route.name === 'Home' ||
                        $router.currentRoute.path === '/transmission'
                "
                @click="$router.push({ path: '/inspectionsList' })"
            >
                Lista Vistorias
            </b-dropdown-item>

            <b-dropdown-item
                v-if="$route.name === 'Home'"
                @click="$router.push({ path: '/changelog' })"
            >
                Changelog
            </b-dropdown-item>

            <b-dropdown-item
                v-if="$router.currentRoute.path == '/inspectionsList' && pendingTransmissions"
                @click="$router.push({ path: '/transmission' })"
            >
                Enviar vistorias pendentes
            </b-dropdown-item>

            <b-dropdown-item v-if="$route.name === 'Home'" @click="logoff" class="mt-2 border-top">
                Sair
            </b-dropdown-item>
        </b-dropdown>

        <b-modal
            id="modal-import-db"
            title="Importar dados (.json)"
            hide-footer
            @hide="fecharModalImportacao"
        >
            <b-form-file
                v-model="jsonBanco"
                :state="Boolean(jsonBanco)"
                placeholder="Escolha um arquivo .json"
                type="file"
                accept="application/JSON"
            >
            </b-form-file>
            <span>{{estadoImportacao}}</span>
            <div class="d-flex justify-content-end">
                <b-button
                    class="mt-2"
                    variant="primary"
                    type="button"
                    @click="() => importarJsonBanco(jsonBanco)"
                    :disabled="!Boolean(jsonBanco)"
                >
                    Carregar
                </b-button>
            </div>
            <hr>
            <footer>
                <small>A importação das vistorias substitui
                    todas as vistorias abaixo, pendentes de envio ou não!</small>
            </footer>
        </b-modal>
    </div>   
</template>

<script>
import { BButton, BDropdown, BDropdownItem, BFormFile, BModal, VBModal } from "bootstrap-vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faBars, faDownload);

import Database from "@/controller/database";
import exportarBanco from "@/utils/exportarBanco";
import IDBExportImport from "indexeddb-export-import";
import Swal from "sweetalert2";

export default {
    components: {
        "font-awesome-icon": FontAwesomeIcon,
        BDropdown,
        BDropdownItem,
        BModal,
        BFormFile,
        BButton
    },
    directives: {
        "b-modal": VBModal
    },
    data: function () {
        return {
            pendingTransmissions: false,
            jsonBancoCarregado: false,
            jsonBanco: null,
            estadoImportacao: null,
        };
    },
    methods: {
        fecharModalImportacao() {
            this.jsonBanco = null;
            if(this.estadoImportacao === "Sucesso!") {
                location.reload();
            }
            this.estadoImportacao = null;
        },
        async mostraAlertPendentes() {
            const database = new Database();
            await database
                .createOrOpenDatabase({ listInspection: true })
                .then((response) => (this.inspections = response))
                .catch(() => (this.inspections = []));

            for (let i = 0; i < this.inspections.length; i++) {
                let vistoria = this.inspections[i];
                if (vistoria.status == "Pendente") {
                    this.pendingTransmissions = true;
                }
            }
        },
        cancelInspection: function () {
            Swal.fire({
                title: "Deseja cancelar a vistoria?",
                text: "Não será possível reverter!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Continuar Vistoria",
                confirmButtonText: "Cancelar",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$router.push({ path: "/home" });
                }
            });
        },
        importarJsonBanco(jsonBancoFile) {
            return new Promise((resolve, reject) => {
                const request = window.indexedDB.open("Inovaclickteste", 1);

                request.onerror = (err) => {
                    console.error("error criacao/abertura do banco indexed");
                    reject(err);
                };

                request.onsuccess = async (event) => {
                    let db = event.target.result;
                    this.estadoImportacao = "Importando...";
                    const jsonBanco = await jsonBancoFile.text();
                    IDBExportImport.clearDatabase(db, (err) => {
                        if (err) {
                            console.error(err);
                            this.estadoImportacao = "FALHA";
                            return;
                        } else {
                            IDBExportImport.importFromJsonString(db, jsonBanco, (err) => {
                                if (err) {
                                    this.estadoImportacao = "FALHA";
                                    console.error(err);
                                }
                                this.estadoImportacao = "Sucesso!";
                                resolve();
                            });
                        }
                    });
                    
                    resolve();
                };
            });
        },
        exportarBanco,
        logoff: function () {
            Swal.fire({
                title: "Deseja sair?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Continuar",
                confirmButtonText: "Sair",
            }).then((result) => {
                if (result.isConfirmed) {
                    localStorage.clear();
                    this.$router.push({ path: "/login" });
                }
            });
        },
    },
    mounted: async function () {
        this.mostraAlertPendentes();
    },
};
</script>

<style scoped>
.dropdown-white {
    background-color: white;
}
</style>
